import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import Banner from "./Banner/Banner.jsx";
import usdaLogo from "assets/img/usda-symbol.svg";
import fsLogo from "assets/img/usfslogo.svg";
import closeIcon from "assets/fsdp/img/close.svg";
import "./Header.css";

function Header({ mapVersion = false }) {
  Header.propTypes = {
    mapVersion: PropTypes.bool,
  };
  return (
    <div className="header-container">
      <a href="#main-content" className="usa-skip-link">
        Skip to main content
      </a>
      <Banner mapVersion={mapVersion} />
      <div className="usa-overlay">skip to main content</div>
      <header role="banner" id="header">
        <div
          className={
            "primary-container" + (mapVersion ? " map-site-header" : "")
          }
        >
          <div className="header-left">
            <a href="https://www.usda.gov" target="_blank" rel="noreferrer">
              <img
                className="usda-logo"
                src={usdaLogo}
                alt="U.S. Department of Agriculture"
              />
            </a>
            <a href="https://www.fs.usda.gov/" target="_blank" rel="noreferrer">
              <img className="fs-logo" src={fsLogo} alt="U.S. Forest Service" />
            </a>
            <div className="fs-usda-container desktop">
              <div>
                <span className="fs-name">Forest Service</span>
              </div>
              <div className="usda-name">U.S. DEPARTMENT OF AGRICULTURE</div>
            </div>
          </div>
          <div className="vert-divider desktop" />

          <div className="header-right">
            <a href="/" target="_blank" className="site-header-text">
              Forest Pest Conditions
            </a>
          </div>

          <button className="usa-menu-btn">MENU</button>
        </div>
        <div className="usa-header usa-header--extended">
          <nav
            aria-label="Primary navigation"
            className="usa-nav"
            role="navigation"
          >
            <div className="usa-nav__inner">
              <button className="usa-nav__close">
                <img src={closeIcon} alt="Close Menu" />
              </button>
              <ul className="usa-nav__primary usa-accordion">
                {mapVersion && (
                  <Fragment>
                    <li className="usa-nav__primary-item small-height first-logo">
                      <a
                        href="https://www.usda.gov"
                        target="_blank"
                        rel="noreferrer"
                        className="logo-link"
                      >
                        <img
                          className="usda-logo"
                          src={usdaLogo}
                          alt="U.S. Department of Agriculture"
                        />
                      </a>
                    </li>
                    <li className="usa-nav__primary-item small-height">
                      <a
                        href="https://www.fs.usda.gov/"
                        target="_blank"
                        rel="noreferrer"
                        className="logo-link"
                      >
                        <img
                          className="fs-logo"
                          src={fsLogo}
                          alt="USFS logo"
                          aria-label="U.S. Forest Service"
                        />
                      </a>
                    </li>
                  </Fragment>
                )}
                <li className="usa-nav__primary-item">
                  <NavLink className="usa-nav__link" to="/home">
                    {mapVersion && (
                      <span className="small-height">
                        Forest Pest Conditions{" "}
                      </span>
                    )}
                    Home
                  </NavLink>
                  <span></span>
                </li>
                <li className="usa-nav__primary-item">
                  <NavLink className="usa-nav__link" to="/map">
                    Interactive Map
                  </NavLink>
                </li>
                <li className="usa-nav__primary-item">
                  <NavLink className="usa-nav__link" to="/pest-information">
                    Pest Information
                  </NavLink>
                </li>
                <li className="usa-nav__primary-item">
                  <NavLink className="usa-nav__link" to="/national-reports">
                    National Reports
                  </NavLink>
                </li>
                <li className="usa-nav__primary-item">
                  <NavLink className="usa-nav__link" to="/contact">
                    Contacts
                  </NavLink>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>
    </div>
  );
}

export default Header;
